import "../assets/css/merchandises.css";
import { useState, useEffect } from "react";
import { Loading } from "../components/loading";
import { MediaSlider } from "../components/mediaSlider";

export const Merchandises = ({ merchandises, isShowSectionTitle = true }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (merchandises && merchandises.length > 0) {
      setLoading(false);
    }
  }, [merchandises, isShowSectionTitle]);

  return (
    <section id="merchandises">
      {loading ? (
        <Loading />
      ) : (
        <div className="merchandises-container">
          {isShowSectionTitle && (
            <div>
              <h3>MERCHANDISES</h3>
              <hr />
            </div>
          )}
          <MediaSlider mediaList={merchandises} />
        </div>
      )}
    </section>
  );
};
